import React from 'react';
import FullScreenSpinner from '../../Shared/FullScreenSpinner';

// this component is used in pq app's auth flow to pass the code and state in query param EC-1119
const AppRedirection: React.FunctionComponent = () => {
    return <FullScreenSpinner />;
};

export default AppRedirection;
